module.exports = __webpack_public_path__ + "static/don46-fd6807b61f7b0765f1528c3fb2369c5d.jpg";